import BaseServiceCrud from './BaseServiceCrud';

export default class CompanyLocationImportService extends BaseServiceCrud {
    constructor() {
        super();
        this.path = 'bo-company-location-import';
    }

    upload(file) {
        const formData = new FormData();
        formData.append('file', file);
        return this.fetch(
            `${this.domain}/${this.path}/upload`,
            {
                method: 'POST',
                body: formData,
            },
            {
                Accept: 'application/json',
                'Cache-Control': 'no-cache, no-store, must-revalidate',
                Pragma: 'no-cache',
                locale: sessionStorage.getItem('i18nextLng'),
            }
        ).then((res) => Promise.resolve(res));
    }

    getImportByUuid(uuid) {
        const query = this.objToQueryString({
            first_result: 0,
            max_result: 1,
            sort_field: 'createdDateTime',
            sort_asc: false,
            uuid,
        });
        return this.fetch(`${this.domain}/${this.path}/imports${query}`, {
            method: 'GET',
        }).then((res) => Promise.resolve(res));
    }

    getErrorLogs(locationImportId) {
        const query = this.objToQueryString({
            first_result: 0,
            max_result: 5000,
            sort_field: 'csvRecordNumber',
            sort_asc: true,
            locationImportId,
            status: 'ERROR',
        });
        return this.fetch(`${this.domain}/${this.path}/import-logs${query}`, {
            method: 'GET',
        }).then((res) => Promise.resolve(res));
    }
}
